import React from 'react'

import {
    Breadcrumb,
    Layout,
    Modal,
    Tooltip,
    message,
    Table,
    Spin,
    Row,
    Col
} from 'antd'
import {Divider} from 'antd'
import SplitterLayout from 'react-splitter-layout'
import 'react-splitter-layout/lib/index.css'
import './maps.css'
import Toolbar from '../commons/Toolbar'
import _ from 'lodash'
import Settings from '../commons/StatelessSettings'
import SettingsHandler from '../commons/SettingsHandler'
import mapsService from '../services/maps.service'
import fileUploadService from '../services/file.upload.service'
import fileDownloadService from '../services/file.download.service'
import userService from '../services/users.service'
import authService from '../services/authentication.service'
import * as constants from '../commons/constants'
import {findFolder, getFolderPath, isAncestor} from '../utils/functions'
import GenericModal from '../commons/GenericModal'
import FolderTree from '../commons/FolderTree'
import DocumentSearch from '../commons/DocumentSearch'

import {formatFileSize} from '../utils/functions'



const {Content, Sider} = Layout
const {confirm} = Modal

class MapsView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            loadingTree: true,
            collapsed: true,
            treeData: [],
            selectedFolder: {
                _id: null,
            },
            modal: {
                visible: false,
                action: null,
                data: [],
            },
            maps: [],
            folderPath: 'Maps',
            expandedKeys: [],
            users: [],
            searchString: null,
            settings: {
                users:[]
            },
            selectedRowKeys:[],
            loadingTable: false,
        }
        this.settingsHandler = new SettingsHandler(this, mapsService);
        this.upload = null
        this.ctrlKey = false
        this.selectedFolderName = ''
        this.currentTreeAction = ''

        this.columns = [
            {
                title: 'Name',
                dataIndex: 'originalname',
                render: (text, record) => {
                    return (
                        <Tooltip title={record.comments}>{record.originalname}</Tooltip>
                    )
                },
            },
            {
                title: 'Uploaded by',
                dataIndex: 'uploadedBy',
                sorter: true,
            },
            {
                title: 'Upload date',
                dataIndex: 'uploadDate',
                render: (text, record) => {
                    return record.uploadDate.substring(0, 19)
                },
                sorter: true,
            },
            {
                title: 'Type',
                dataIndex: 'extension',
                sorter: true,
            },
            {
                title: 'Size',
                dataIndex: 'size',
                render: (text, record) => {
                    return formatFileSize(record.size)
                },
                sorter: true,
            },
        ]
        this.selectedRows = [];
        this.user = authService.getAuthenticatedUser()
    }

    handleOnClickMenu = ({item, key, keyPath, domEvent}) => {
        domEvent.preventDefault()
        domEvent.stopPropagation()
        console.log('handleOnClickMenu:', item, key)
        this.currentTreeAction = key
        if (key === constants.UPLOAD_FILES) {
            this.upload.click()
        }

        if (key === constants.ADD_FOLDER) {
            this.setState({
                modal: {
                    visible: true,
                    action: key,
                    data: '',
                },
            })
        }

        if (key === constants.RENAME_FOLDER) {
            this.setState({
                modal: {
                    visible: true,
                    action: key,
                    data: this.selectedFolderName,
                },
            })
        }

        if ( key == constants.CUT_FOLDER){
            this.cutFolderId = this.state.selectedFolder._id;
        }

        if ( key == constants.PASTE_FOLDER){

            this.moveFolder(this.cutFolderId, this.state.selectedFolder._id)
            this.cutFolderId = null;
        }

        if ( key == constants.DELETE_FOLDER){
            this.deleteFolder(this.state.selectedFolder)
        }
    }

    handleModalOk = async data => {
        console.log(data)

        if (this.currentTreeAction === constants.ADD_FOLDER) {
            //passing iconCls to keep backward compatibility
            const folder = {
                text: data,
                iconCls: 'icon-folder-open',
                _parentId: this.state.selectedFolder._id,
            }

            const savedFolder = await mapsService.saveFolder(
                folder,
                this.state.folderPath
            )

            if (!this.state.selectedFolder.children) {
                this.state.selectedFolder.children = []
            }
            this.state.selectedFolder.children.push(savedFolder)
            this.state.expandedKeys.push(savedFolder._id)
            console.log('expandedKey:', this.state.expandedKeys)
            this.setState({
                treeData: this.state.treeData,
                selectedFolder: savedFolder,
                expandedKeys: this.state.expandedKeys,
            })
        }

        if (this.currentTreeAction === constants.RENAME_FOLDER) {
            const folder = this.state.selectedFolder
            folder.text = data
            const savedFolder = await mapsService.saveFolder(
                folder,
                this.state.folderPath
            )
            this.setState({treeData: this.state.treeData})
        }
        this.closeModal()
    }

    closeModal = () => {
        this.setState({modal: {visible: false, data: {}}})
    }

    setUploadProgress = (filename, percent, status) => {
        const data = this.state.modal.data
        data[filename] = {name: filename, percent: percent, status: status}
        this.setState({
            modal: {visible: true, action: constants.UPLOAD_FILES, data: data},
        })
    }

    handleOnUploadProgress = (filename, percent) => {
        console.log('handleOnUploadProgress', filename, percent)
        this.setUploadProgress(filename, percent, 'active')
    }

    handleOnChangeFile = event => {
        try {
            event.stopPropagation()
            event.preventDefault()
            const files = event.target.files
            const folderId = this.state.selectedFolder._id
            let data = {}
            for (let file of files) {
                data[file.name] = {name: file.name, percent: 0, status: 'active'}
                fileUploadService
                    .sendFile(file, {
                        name: 'documents',
                        params: {
                            folderId: folderId,
                            folderPath: getFolderPath(this.state.treeData, folderId),
                        },
                        onProgress: this.handleOnUploadProgress,
                        url: '/api/v1/maps/upload',
                    })
                    .then(file => {
                        console.log('file uploaded successfully', file)
                        this.setUploadProgress(file.originalname, 100, 'success')
                        this.setState({maps: [...this.state.maps, file]})
                    })
                    .catch(error => {
                        console.log('error uploading file', error)
                        this.setUploadProgress(error.filename, 100, 'exception')
                    })
            }
            this.setState({modal: {visible: true, action: 'upload', data: data}})
        }
        finally {
            console.log('attaching event listener onchange for file...')
            this.upload.addEventListener('change', this.handleOnChangeFile, false);
        }
    }

    handleDownload = () => {
        const MAX = 10;
        if (this.selectedRows.length < 1){
            return;
        }
        else if (this.selectedRows.length == 1) {
            const file = this.selectedRows[0]
            const url = `/api/v1/maps/file/download/?fileId=${file._id}&folderPath=${this.state.folderPath}`
            window.open(url);
            //fileDownloadService.download(url, file.originalname)
        }
        else if ( this.selectedRows.length > 1 && this.selectedRows.length <= MAX ) {
            const arrayOfStringIds = _.map(this.selectedRows, '_id')
            try {
                fileDownloadService.download(
                    '/api/v2/maps/download',
                    null,
                    {
                        method: 'POST',
                        body: JSON.stringify(arrayOfStringIds),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                )
            } catch (err) {
                console.error('Error: ', err)
            }
        }
        else{
            message.info('Max of 10 documents are allowed');
        }

    }

    handleDelete = () => {

        if (this.selectedRows.length < 1){
            return;
        }

        confirm({
            title: 'Are you sure you want to delete these documents?',
            content: 'After clicking OK the photos will be deleted permanently',
            onOk: async () => {
                console.log('OK')
                for (let file of this.selectedRows) {
                    await mapsService.deleteMap(file._id)
                }
                const filtered = this.state.maps.filter(m => {
                    let found = false
                    for (let file of this.selectedRows) {
                        if (file._id === m._id) {
                            found = true
                            break
                        }
                    }
                    return !found
                })
                this.setState({maps: filtered})
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }

    handleLoadData = treeNode => {
        const folderId = treeNode.props.dataRef._id;
        console.log('handleLoadData: folderId=', folderId);
        return new Promise(resolve => {
            if (!_.isEmpty(treeNode.props.children)) {
                resolve();
                return;
            }
            mapsService.getTreeData(folderId).then(data => {
                treeNode.props.dataRef.children = data;
                this.setState({
                    treeData: [...this.state.treeData]
                });
                resolve();
            }).catch(error => {
                console.error(error)
            });
        });
    }

    moveFiles = async (fileIds, folderId) => {
        console.log('moveFiles:', fileIds, folderId)
        const rsp = await mapsService.moveFiles(fileIds, folderId)
        if (rsp.rspCode === 'ok') {
            const documents = await mapsService.getMaps(folderId);
            this.setState({maps: documents})
            this.selectedRows = []
            /*this.state.documents
            const filtered = _.filter(
                this.state.photos,
                p => !fileIds.includes(p._id)
            )
            this.setState({photos: filtered})*/
            message.success('Files moved successfully')
        } else {
            message.error('Error occurred while moving files')
        }
        console.log('moveFiles:', rsp)
    }

    moveFolder = async (srcFolderId, targetFolderId) => {
        console.log('moveFolder:', srcFolderId, targetFolderId)

        if ( isAncestor(srcFolderId, targetFolderId, this.state.treeData) ){
            message.error("Cannot move folder to one of its children...")
            return;
        }

        if (srcFolderId === targetFolderId ) return;

        const rsp = await mapsService.moveFolder(srcFolderId, targetFolderId)
        if (rsp.rspCode === 'ok') {
            /**  This logic needs to be optimized **/
            const srcFolder = findFolder(srcFolderId, this.state.treeData)
            const srcParent = findFolder(srcFolder._parentId, this.state.treeData)
            const targetFolder = findFolder(targetFolderId, this.state.treeData)
            srcFolder._parentId = targetFolder._id
            if (!targetFolder.children) targetFolder.children = []
            targetFolder.children.push(srcFolder)
            _.remove(srcParent.children, child => {
                return child._id === srcFolder._id
            })
            this.setState({
                folderPath: getFolderPath(this.state.treeData, srcFolderId),
            })
            this.setState({treeData: this.state.treeData})
            message.success('Folder moved successfully')
        } else {
            message.error('Error occurred while moving folder')
        }
        console.log('moveFolder:', rsp)
    }

    deleteFolder = async (folder) => {
        const folderId = folder._id;
        confirm({
            title: 'Are you sure you want to delete this Folder?',
            content: 'After clicking OK folder will be deleted',
            onOk: async () => {
                const rsp = await mapsService.deleteFolder(folderId)
                if (rsp.rspCode === "error") {
                    message.error(rsp.msg);
                }
                else {
                    const parent = findFolder(folder._parentId, this.state.treeData)
                    _.remove(parent.children, child => {
                        return child._id === folder._id
                    })
                    this.setState({ treeData: this.state.treeData })
                    message.success('Folder delete successfully')
                }
            },
            onCancel() {
                console.log('Cancel')
            },
        })


    }

    showSettings = () => {
        const mapOn = this.state.mapOn
        const collapsed = this.state.collapsed
        if (collapsed && mapOn) {
            console.log('something is wrong. This should never happen!!!')
        }
        if ((collapsed && !mapOn) || (!collapsed && !mapOn)) {
            this.setState({
                collapsed: !collapsed,
            })
        }
        if (!collapsed && mapOn) {
            this.setState({
                mapOn: false,
            })
        }
    }

    getFirstSelectedFile = () => {
        return !_.isEmpty(this.selectedRows)
            ? this.selectedRows[0]
            : undefined
    }

    updateSettings = (folder, file, users) =>{
        const folderLink = folder.publicLink
        const securityDetail = folder.securityDetail
        const selectedOwner = securityDetail ? securityDetail.owner : ''

        const selectedGuests = securityDetail
            ? _.map(securityDetail.guests, g => g.username)
            : []

        const iconColor = folder.stateColor
        let textStyle = []
        if (folder.textBoldStyle)
            textStyle.push(folder.textBoldStyle.value)
        if (folder.textItalicStyle)
            textStyle.push(folder.textItalicStyle.value)

        const textSize = folder.textSize ? folder.textSize.option : undefined
        const folderComments = folder.comments
        const fileComments = file ? file.comments : ''
        const fileLink = file ? file.publicLink : ''

        this.setState({
            settings: {
                selectedOwner: selectedOwner,
                selectedGuests: selectedGuests,
                users: users,
                folderLink: folderLink,
                iconColor: iconColor,
                textSize: textSize,
                textStyle: textStyle,
                file: file,
                fileComments: fileComments,
                fileLink: fileLink,
                folderComments: folderComments
            }
        });
    }

    onSelect = async (keys, event) => {
        const node = event.selectedNodes[0]
        const folderId = keys[0]
        const selectedFolder = findFolder(folderId, this.state.treeData)
        this.setState({
            selectedFolder: selectedFolder,
            folderPath: getFolderPath(this.state.treeData, folderId),
            selectedRowKeys: []
        })
        this.updateSettings(selectedFolder, null, this.state.settings.users);
        this.setState({loadingTable: true})
        const maps = await mapsService.getMaps(keys[0])
        this.selectedFolderName = node.props.dataRef.text
        this.removeFolderPathColumn(this.columns)
        this.setState({maps: maps, loadingTable: false})
        this.selectedRows = []

    }

    onExpand = keys => {
        console.log('Trigger Expand', keys)
        this.setState({expandedKeys: keys})
    }

    reRenderTree = () => {
        this.setState({})
    }

    componentDidMount() {
        mapsService
            .getTreeData()
            .then(data => {
                this.setState({
                    treeData: data,
                    selectedFolder: data[0],
                    expandedKeys: [data[0]._id],
                    loading: false,
                    loadingTree: false,
                });
                return  userService.getUsers();
            })
            .then( users => {
                this.state.users = users;
                this.updateSettings(this.state.selectedFolder, null, this.state.users);
            })
            .catch(error => {
                console.log(error)
            })

    }

    renderBreadCrums = folderPath => {
        const paths = folderPath.split('/')
        return paths.map(p => {
            if (p.trim() !== '') {
                return <Breadcrumb.Item> {p}</Breadcrumb.Item>
            }
        })
    }

    addFolderPathColumn = (columns) => {
        const found = columns.find( c => c.title === 'Path' )
        if ( !found ) {
            const pathColumn = {
                title: 'Path',
                dataIndex: 'folderPath',
                sorter: true,
            }
            columns.splice(1, 0, pathColumn)
        }
    }

    removeFolderPathColumn = (columns) => {
        const found = columns.find( c => c.title === 'Path' )
        if ( found ) {
            columns.splice(1, 1)
        }
    }

    render() {

        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                });
                this.selectedRows = selectedRows;
                this.updateSettings(this.state.selectedFolder, selectedRows[0], this.state.users);
            }
        }

        const owner = this.user.isFolderOwner(this.state.selectedFolder)
        const admin = this.user.hasRole(['Administrator']);
        const supervisor = this.user.hasRole(['Supervisor']);

        const toolBarItems = [
            {
                title: 'cut',
                icon: 'scissor',
                onClick: () => {
                   this.cutRowKeys = this.state.selectedRowKeys;
                },
                display: admin || owner
            },
            {
                title: 'paste',
                icon: 'snippets',
                onClick: () => {
                    this.moveFiles(this.cutRowKeys, this.state.selectedFolder._id)
                    this.cutRowKeys = null
                },
                display: admin || owner
            },
            {
                title: 'delete',
                icon: 'delete',
                onClick: this.handleDelete,
                display: admin || supervisor || owner
            },
            {
                title: 'download',
                icon: 'download',
                onClick: this.handleDownload,
                display: true
            },
            {
                title: 'settings',
                icon: 'setting',
                onClick: this.showSettings,
                display: admin || supervisor || owner
            },

        ]

        return (
            <div style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
                <input
                    type="file"
                    id="file"
                    ref={e => {
                        this.upload = e
                    }}
                    style={{display: 'none'}}
                    multiple
                    onChange={this.handleOnChangeFile}
                />
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        {this.renderBreadCrums(this.state.folderPath)}
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={12}>
                        <DocumentSearch
                            onSearch={async value => {
                                if (!value) {
                                    this.setState({
                                        maps: [],
                                        searchString: null,
                                    })
                                } else {
                                    this.setState({loadingTable: true});
                                    const maps = await mapsService.searchMaps(value)
                                    this.addFolderPathColumn(this.columns)
                                    this.setState({
                                        maps,
                                        searchString: value,
                                        loadingTable: false,
                                    })
                                }
                            }}
                        />
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>


                <div id="documentsContentPanel" style={{flex: 'auto', display: 'flex', flexDirection: 'column', overflow: 'auto', boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)',}}>
                        <SplitterLayout primaryIndex={1} secondaryInitialSize={225}>
                            <Spin spinning={this.state.loadingTree} tip="Loading tree...">
                                <div style={{flex: 'auto', display: 'flex', flexDirection: 'column', height: '100px', overflowY: 'auto'}}>
                                    <FolderTree
                                        onSelect={this.onSelect}
                                        onExpand={this.onExpand}
                                        selectedKeys={[this.state.selectedFolder._id]}
                                        expandedKeys={this.state.expandedKeys}
                                        treeData={this.state.treeData}
                                        onClickMenu={this.handleOnClickMenu}
                                        onMoveFiles={this.moveFiles}
                                        onMoveFolder={this.moveFolder}
                                        onLoadData={this.handleLoadData}
                                        permissions={this.state.selectedFolder.allowedActions}
                                    />
                                </div>
                            </Spin>
                            <div
                                id="documentContainer"
                                style={{
                                    flex: '1 1 auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height:'100px',
                                }}
                            >
                                <Layout>
                                    <Content>
                                        <section
                                            id="documents-default"
                                            style={{padding: '0px 3px'}}
                                        >
                                            <Table
                                                size="middle"
                                                rowKey={'_id'}
                                                columns={this.columns}
                                                dataSource={this.state.maps}
                                                rowClassName={(record, index) =>
                                                    this.state.selectedRowKeys &&
                                                    this.selectedRows
                                                        ? index === this.state.selectedRowKeys[0] &&
                                                        record === this.state.selectedRows[0]
                                                        ? 'highlight'
                                                        : ''
                                                        : null
                                                }
                                                loading={this.state.loadingTable}
                                                pagination={false}
                                                rowSelection={rowSelection}
                                            />
                                        </section>
                                    </Content>

                                    <Sider
                                        trigger={null}
                                        collapsible
                                        collapsed={this.state.collapsed}
                                        style={{background: '#fff'}}
                                        width={450}
                                        collapsedWidth={0}
                                    >
                                        <div style={{padding: '10px'}}>

                                                <Settings
                                                    data={this.state.settings}
                                                    handler={this.settingsHandler}
                                                    shareFolder={false}
                                                    shareFile={true}
                                                    authUser={this.user}
                                                />
                                        </div>
                                    </Sider>
                                </Layout>
                            </div>
                        </SplitterLayout>
                </div>
                <GenericModal
                    visible={this.state.modal.visible}
                    onOk={this.handleModalOk}
                    onCancel={this.closeModal}
                    data={this.state.modal.data}
                    action={this.state.modal.action}
                />
            </div>
        )
    }
}

export default MapsView
